import React from 'react';
import { i18n } from 'config/locales';
import classnames from 'classnames';
import { Modal } from '../../Modal';
import SvgComponent from '../SvgComponent';

const ACTION_SPIN = 'spin';
const ACTION_SHRINK = 'shrink';
const ACTION_GROW = 'grow';

export const SpinnerAction = {
  Spin: ACTION_SPIN,
  Shrink: ACTION_SHRINK,
  Grow: ACTION_GROW,
};

export default class Spinner extends React.PureComponent {
  render() {
    const isActionGrow = this.props.action === ACTION_GROW;

    return (
      <Modal show={this.props.show} className={classnames('spinner', this.props.className)}>
        <div
          className={classnames('spinner-icon', {
            hidden: isActionGrow,
            [this.props.action]: !isActionGrow,
          })}
        >
          {this.props.label}
        </div>
        <div className={classnames(this.props.icon, {
          grow: isActionGrow,
          hidden: !isActionGrow,
        })}
          aria-hidden="true">
          <SvgComponent
            aria-hidden="false"
            src="/img/circle-check.svg" />
        </div>
        <span className="spinner-label">{this.props.label}</span>
      </Modal>
    );
  }
}

Spinner.defaultProps = {
  className: '',
  show: false,
  action: ACTION_SPIN,
  label: i18n.t('spinner.label'),
  icon: 'circle-check',
};
